import React, { useEffect, useState } from 'react';
import { Pencil, Save } from 'lucide-react';
import api from '../lib/api';
import { toast } from '../hooks/use-toast';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';

const inp = 'w-full bg-muted/40 border border-border rounded-[3px] px-2.5 py-2 text-[13px] outline-none focus:border-primary transition-colors';
const FIELDS = [
  ['first_name', 'Nome', 'col-span-1'],
  ['last_name', 'Sobrenome', 'col-span-1'],
  ['phone', 'Telefone', 'col-span-1'],
  ['email', 'E-mail', 'col-span-1'],
  ['preferred_contact', 'Contato preferido', 'col-span-1'],
  ['vehicle_interest', 'Veículo de interesse', 'col-span-1'],
];

// Edição liberada para todos: o dado corrigido aqui vale em todo o sistema e fica logado.
export const EditLeadCustomerDialog = ({ lead, open, onClose, onDone }) => {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open || !lead) return;
    setForm({
      first_name: lead.first_name || '', last_name: lead.last_name || '', phone: lead.phone || '',
      email: lead.email || '', preferred_contact: lead.preferred_contact || '',
      vehicle_interest: lead.vehicle_interest || '', message: lead.message || '',
    });
  }, [open, lead]);

  const save = async () => {
    if (!form.first_name?.trim() && !form.phone?.trim() && !form.email?.trim()) {
      toast({ title: 'Faltou identificar o cliente', description: 'Informe pelo menos nome, telefone ou e-mail.' });
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put(`/bdc-leads/${lead.id}/customer`, form);
      toast({
        title: data.changed ? 'Dados atualizados em todo o sistema' : 'Nada mudou',
        description: data.changed ? (data.changes || []).slice(0, 3).join(' · ') : undefined,
      });
      onDone && onDone();
      onClose();
    } catch (e) {
      toast({ title: 'Erro ao salvar', description: e.response?.data?.detail || 'Tente novamente.' });
    } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="bg-card border-border text-foreground max-w-lg">
        <DialogHeader>
          <DialogTitle className="ent-coltitle uppercase tracking-wide flex items-center gap-2">
            <Pencil className="w-3.5 h-3.5" /> Editar dados do cliente
          </DialogTitle>
        </DialogHeader>
        <p className="text-[11.5px] t-label -mt-1">A correção é replicada na ficha do cliente, CRM, deals, pós-venda e agenda, com log de alteração.</p>
        <div className="grid grid-cols-2 gap-2.5">
          {FIELDS.map(([key, label, span]) => (
            <div key={key} className={span}>
              <label className="ent-label block mb-1">{label}</label>
              <input data-testid={`edit-lead-${key}`} className={inp} value={form[key] || ''}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })} />
            </div>
          ))}
          <div className="col-span-2">
            <label className="ent-label block mb-1">Mensagem / observação do lead</label>
            <textarea data-testid="edit-lead-message" rows={3} className={`${inp} resize-y`} value={form.message || ''}
              onChange={(e) => setForm({ ...form, message: e.target.value })} />
          </div>
        </div>
        <DialogFooter>
          <button data-testid="edit-lead-cancel" onClick={onClose} className="ent-btn ent-btn-sm">Cancelar</button>
          <button data-testid="edit-lead-save" onClick={save} disabled={saving} className="ent-btn ent-btn-primary">
            <Save className="w-3.5 h-3.5" /> {saving ? 'Salvando...' : 'Salvar alterações'}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
